export default defineNuxtPlugin({
  name: 'sv:business-area-state',
  setup(app) {
    // Called by useDrupalRoute.
    app.hooks.hook('vuepal:drupal-route', (data) => {
      setBusinessAreaFromRoute(data.routeQuery)
    })
  },
})
